/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../../../shared/api/custom-instance';

import { customInstance } from '../../../../shared/api/custom-instance';
import type {
  BulkDeleteProjectsRequest,
  DeleteProjectResponse,
  ErrorResponse,
  GetProjectsOptionsParams,
  GetProjectsParams,
  IdResponse,
  ListAgentChatThreadsParams,
  PagedProjectListResponse,
  ProjectAgentChatCreateTurnRequest,
  ProjectAgentChatThreadCreateRequest,
  ProjectAgentChatThreadDetailResponse,
  ProjectAgentChatThreadFavoriteRequest,
  ProjectAgentChatThreadListResponse,
  ProjectAgentChatThreadUpdateRequest,
  ProjectAgentChatTurnDetailResponse,
  ProjectCreateRequest,
  ProjectCreateResponse,
  ProjectDetailResponse,
  ProjectEucsListResponse,
  ProjectReferenceChatCreateRequest,
  ProjectReferenceChatDetailResponse,
  ProjectsOptionsResponse,
  ProjectUpdateRequest,
  ProjectUpdateResponse,
  ReferenceChatAvailabilitiesResponse,
  ReferenceChatBulkCreateRequest,
  SuccessResponse,
  TagCreateRequest,
  TagUpdateRequest,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 事業一覧取得

フィルタリング、検索、ページネーションに対応

 * @summary 事業一覧取得
 */
export const getProjects = (
  params?: GetProjectsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PagedProjectListResponse>(
    { url: `/projects`, method: 'GET', params, signal },
    options,
  );
};

export const getGetProjectsQueryKey = (params?: GetProjectsParams) => {
  return [`/projects`, ...(params ? [params] : [])] as const;
};

export const getGetProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError = ErrorType<void>,
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjects>>> = ({ signal }) =>
    getProjects(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjects>>>;
export type GetProjectsQueryError = ErrorType<void>;

export function useGetProjects<
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError = ErrorType<void>,
>(
  params: undefined | GetProjectsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjects>>,
          TError,
          Awaited<ReturnType<typeof getProjects>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjects<
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError = ErrorType<void>,
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjects>>,
          TError,
          Awaited<ReturnType<typeof getProjects>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjects<
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError = ErrorType<void>,
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 事業一覧取得
 */

export function useGetProjects<
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError = ErrorType<void>,
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 事業作成

 * @summary 事業作成
 */
export const createProject = (
  projectCreateRequest: BodyType<ProjectCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ProjectCreateResponse>(
    {
      url: `/projects`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: projectCreateRequest,
      signal,
    },
    options,
  );
};

export const getCreateProjectMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProject>>,
    TError,
    { data: BodyType<ProjectCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProject>>,
  TError,
  { data: BodyType<ProjectCreateRequest> },
  TContext
> => {
  const mutationKey = ['createProject'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProject>>,
    { data: BodyType<ProjectCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createProject(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createProject>>>;
export type CreateProjectMutationBody = BodyType<ProjectCreateRequest>;
export type CreateProjectMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 事業作成
 */
export const useCreateProject = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createProject>>,
      TError,
      { data: BodyType<ProjectCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createProject>>,
  TError,
  { data: BodyType<ProjectCreateRequest> },
  TContext
> => {
  const mutationOptions = getCreateProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 事業タグを新規作成する。

管理者権限が必要。

 * @summary タグ作成
 */
export const createProjectTag = (
  tagCreateRequest: BodyType<TagCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<IdResponse>(
    {
      url: `/project-tags`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tagCreateRequest,
      signal,
    },
    options,
  );
};

export const getCreateProjectTagMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProjectTag>>,
    TError,
    { data: BodyType<TagCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProjectTag>>,
  TError,
  { data: BodyType<TagCreateRequest> },
  TContext
> => {
  const mutationKey = ['createProjectTag'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProjectTag>>,
    { data: BodyType<TagCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createProjectTag(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProjectTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProjectTag>>
>;
export type CreateProjectTagMutationBody = BodyType<TagCreateRequest>;
export type CreateProjectTagMutationError = ErrorType<ErrorResponse>;

/**
 * @summary タグ作成
 */
export const useCreateProjectTag = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createProjectTag>>,
      TError,
      { data: BodyType<TagCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createProjectTag>>,
  TError,
  { data: BodyType<TagCreateRequest> },
  TContext
> => {
  const mutationOptions = getCreateProjectTagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 事業タグを更新する。

管理者権限が必要。

 * @summary タグ更新
 */
export const updateProjectTag = (
  tagId: string,
  tagUpdateRequest: BodyType<TagUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/project-tags/${tagId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: tagUpdateRequest,
    },
    options,
  );
};

export const getUpdateProjectTagMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectTag>>,
    TError,
    { tagId: string; data: BodyType<TagUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProjectTag>>,
  TError,
  { tagId: string; data: BodyType<TagUpdateRequest> },
  TContext
> => {
  const mutationKey = ['updateProjectTag'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProjectTag>>,
    { tagId: string; data: BodyType<TagUpdateRequest> }
  > = (props) => {
    const { tagId, data } = props ?? {};

    return updateProjectTag(tagId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProjectTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProjectTag>>
>;
export type UpdateProjectTagMutationBody = BodyType<TagUpdateRequest>;
export type UpdateProjectTagMutationError = ErrorType<ErrorResponse>;

/**
 * @summary タグ更新
 */
export const useUpdateProjectTag = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProjectTag>>,
      TError,
      { tagId: string; data: BodyType<TagUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateProjectTag>>,
  TError,
  { tagId: string; data: BodyType<TagUpdateRequest> },
  TContext
> => {
  const mutationOptions = getUpdateProjectTagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 事業タグを削除する。

削除時に紐付けられた事業との関連も解除される。
管理者権限が必要。

 * @summary タグ削除
 */
export const deleteProjectTag = (
  tagId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    { url: `/project-tags/${tagId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteProjectTagMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProjectTag>>,
    TError,
    { tagId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProjectTag>>,
  TError,
  { tagId: string },
  TContext
> => {
  const mutationKey = ['deleteProjectTag'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProjectTag>>,
    { tagId: string }
  > = (props) => {
    const { tagId } = props ?? {};

    return deleteProjectTag(tagId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProjectTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProjectTag>>
>;

export type DeleteProjectTagMutationError = ErrorType<ErrorResponse>;

/**
 * @summary タグ削除
 */
export const useDeleteProjectTag = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteProjectTag>>,
      TError,
      { tagId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteProjectTag>>,
  TError,
  { tagId: string },
  TContext
> => {
  const mutationOptions = getDeleteProjectTagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 指定した事業IDで一括削除する。
関連データ（チャット履歴、タグ紐付け等）も併せて削除される。

 * @summary 事業一括削除
 */
export const bulkDeleteProjects = (
  bulkDeleteProjectsRequest: BodyType<BulkDeleteProjectsRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/projects/bulk/delete`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkDeleteProjectsRequest,
      signal,
    },
    options,
  );
};

export const getBulkDeleteProjectsMutationOptions = <
  TError = ErrorType<ErrorResponse | undefined>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteProjects>>,
    TError,
    { data: BodyType<BulkDeleteProjectsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkDeleteProjects>>,
  TError,
  { data: BodyType<BulkDeleteProjectsRequest> },
  TContext
> => {
  const mutationKey = ['bulkDeleteProjects'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkDeleteProjects>>,
    { data: BodyType<BulkDeleteProjectsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkDeleteProjects(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkDeleteProjectsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkDeleteProjects>>
>;
export type BulkDeleteProjectsMutationBody = BodyType<BulkDeleteProjectsRequest>;
export type BulkDeleteProjectsMutationError = ErrorType<ErrorResponse | undefined>;

/**
 * @summary 事業一括削除
 */
export const useBulkDeleteProjects = <
  TError = ErrorType<ErrorResponse | undefined>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkDeleteProjects>>,
      TError,
      { data: BodyType<BulkDeleteProjectsRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bulkDeleteProjects>>,
  TError,
  { data: BodyType<BulkDeleteProjectsRequest> },
  TContext
> => {
  const mutationOptions = getBulkDeleteProjectsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * EUCデータから事業・マスタ・課を一括作成API

ExpenditureRecordから以下を一括作成する:
- Division（課）
- Master（AccountingType, Kan, Ko, Moku）
- Project（事業）

 * @summary 事業一括作成
 */
export const bulkCreateProjectsFromEuc = (
  eucImportMasterId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponse>(
    { url: `/projects/bulk-create/euc/${eucImportMasterId}`, method: 'POST', signal },
    options,
  );
};

export const getBulkCreateProjectsFromEucMutationOptions = <
  TError = ErrorType<ErrorResponse | undefined>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkCreateProjectsFromEuc>>,
    TError,
    { eucImportMasterId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkCreateProjectsFromEuc>>,
  TError,
  { eucImportMasterId: string },
  TContext
> => {
  const mutationKey = ['bulkCreateProjectsFromEuc'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkCreateProjectsFromEuc>>,
    { eucImportMasterId: string }
  > = (props) => {
    const { eucImportMasterId } = props ?? {};

    return bulkCreateProjectsFromEuc(eucImportMasterId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkCreateProjectsFromEucMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkCreateProjectsFromEuc>>
>;

export type BulkCreateProjectsFromEucMutationError = ErrorType<ErrorResponse | undefined>;

/**
 * @summary 事業一括作成
 */
export const useBulkCreateProjectsFromEuc = <
  TError = ErrorType<ErrorResponse | undefined>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkCreateProjectsFromEuc>>,
      TError,
      { eucImportMasterId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bulkCreateProjectsFromEuc>>,
  TError,
  { eucImportMasterId: string },
  TContext
> => {
  const mutationOptions = getBulkCreateProjectsFromEucMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * ログインユーザーのテナントの都道府県に基づいて、
各リファレンスチャットタイプの利用可否を返却します。

 * @summary リファレンスチャット利用可否取得
 */
export const getReferenceChatAvailabilities = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ReferenceChatAvailabilitiesResponse>(
    { url: `/projects/reference/availabilities`, method: 'GET', signal },
    options,
  );
};

export const getGetReferenceChatAvailabilitiesQueryKey = () => {
  return [`/projects/reference/availabilities`] as const;
};

export const getGetReferenceChatAvailabilitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getReferenceChatAvailabilities>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReferenceChatAvailabilitiesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferenceChatAvailabilities>>> = ({
    signal,
  }) => getReferenceChatAvailabilities(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReferenceChatAvailabilitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReferenceChatAvailabilities>>
>;
export type GetReferenceChatAvailabilitiesQueryError = ErrorType<void>;

export function useGetReferenceChatAvailabilities<
  TData = Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
  TError = ErrorType<void>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReferenceChatAvailabilities>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
          TError,
          Awaited<ReturnType<typeof getReferenceChatAvailabilities>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReferenceChatAvailabilities<
  TData = Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReferenceChatAvailabilities>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
          TError,
          Awaited<ReturnType<typeof getReferenceChatAvailabilities>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReferenceChatAvailabilities<
  TData = Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReferenceChatAvailabilities>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary リファレンスチャット利用可否取得
 */

export function useGetReferenceChatAvailabilities<
  TData = Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReferenceChatAvailabilities>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReferenceChatAvailabilitiesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * division_id と euc_master_id でフィルタし、対象事業に対して一括でリファレンスチャットを作成します。
処理はバックグラウンドで実行されます。

 * @summary 事業のRAG検索チャット一括作成
 */
export const createBulkReferenceChat = (
  referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants',
  referenceChatBulkCreateRequest: BodyType<ReferenceChatBulkCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/projects/reference_chats/${referenceChatType}/bulk`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: referenceChatBulkCreateRequest,
      signal,
    },
    options,
  );
};

export const getCreateBulkReferenceChatMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBulkReferenceChat>>,
    TError,
    {
      referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants';
      data: BodyType<ReferenceChatBulkCreateRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBulkReferenceChat>>,
  TError,
  {
    referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants';
    data: BodyType<ReferenceChatBulkCreateRequest>;
  },
  TContext
> => {
  const mutationKey = ['createBulkReferenceChat'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBulkReferenceChat>>,
    {
      referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants';
      data: BodyType<ReferenceChatBulkCreateRequest>;
    }
  > = (props) => {
    const { referenceChatType, data } = props ?? {};

    return createBulkReferenceChat(referenceChatType, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBulkReferenceChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBulkReferenceChat>>
>;
export type CreateBulkReferenceChatMutationBody = BodyType<ReferenceChatBulkCreateRequest>;
export type CreateBulkReferenceChatMutationError = ErrorType<void>;

/**
 * @summary 事業のRAG検索チャット一括作成
 */
export const useCreateBulkReferenceChat = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBulkReferenceChat>>,
      TError,
      {
        referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants';
        data: BodyType<ReferenceChatBulkCreateRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createBulkReferenceChat>>,
  TError,
  {
    referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants';
    data: BodyType<ReferenceChatBulkCreateRequest>;
  },
  TContext
> => {
  const mutationOptions = getCreateBulkReferenceChatMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * テナント内で事業に紐づいているEUCインポートマスタの一覧を取得する

 * @summary 事業に紐づくEUC一覧取得
 */
export const getProjectEucs = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ProjectEucsListResponse>(
    { url: `/projects/eucs`, method: 'GET', signal },
    options,
  );
};

export const getGetProjectEucsQueryKey = () => {
  return [`/projects/eucs`] as const;
};

export const getGetProjectEucsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectEucs>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectEucs>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectEucsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectEucs>>> = ({ signal }) =>
    getProjectEucs(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectEucs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectEucsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectEucs>>>;
export type GetProjectEucsQueryError = ErrorType<ErrorResponse>;

export function useGetProjectEucs<
  TData = Awaited<ReturnType<typeof getProjectEucs>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectEucs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectEucs>>,
          TError,
          Awaited<ReturnType<typeof getProjectEucs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectEucs<
  TData = Awaited<ReturnType<typeof getProjectEucs>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectEucs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectEucs>>,
          TError,
          Awaited<ReturnType<typeof getProjectEucs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectEucs<
  TData = Awaited<ReturnType<typeof getProjectEucs>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectEucs>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 事業に紐づくEUC一覧取得
 */

export function useGetProjectEucs<
  TData = Awaited<ReturnType<typeof getProjectEucs>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectEucs>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectEucsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * プロジェクトオプション取得API

fieldsパラメータで指定された項目のマスタデータを返す。
例: fields=tag で事業タグ(tag)のマスタデータを取得

 * @summary プロジェクトオプション取得
 */
export const getProjectsOptions = (
  params: GetProjectsOptionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ProjectsOptionsResponse>(
    { url: `/projects/options`, method: 'GET', params, signal },
    options,
  );
};

export const getGetProjectsOptionsQueryKey = (params?: GetProjectsOptionsParams) => {
  return [`/projects/options`, ...(params ? [params] : [])] as const;
};

export const getGetProjectsOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectsOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetProjectsOptionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectsOptions>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectsOptionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectsOptions>>> = ({ signal }) =>
    getProjectsOptions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectsOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectsOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectsOptions>>
>;
export type GetProjectsOptionsQueryError = ErrorType<ErrorResponse>;

export function useGetProjectsOptions<
  TData = Awaited<ReturnType<typeof getProjectsOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetProjectsOptionsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectsOptions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectsOptions>>,
          TError,
          Awaited<ReturnType<typeof getProjectsOptions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectsOptions<
  TData = Awaited<ReturnType<typeof getProjectsOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetProjectsOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectsOptions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectsOptions>>,
          TError,
          Awaited<ReturnType<typeof getProjectsOptions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectsOptions<
  TData = Awaited<ReturnType<typeof getProjectsOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetProjectsOptionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectsOptions>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary プロジェクトオプション取得
 */

export function useGetProjectsOptions<
  TData = Awaited<ReturnType<typeof getProjectsOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetProjectsOptionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectsOptions>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectsOptionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 事業詳細取得
 * @summary 事業詳細取得
 */
export const getProjectsProjectId = (
  projectId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ProjectDetailResponse>(
    { url: `/projects/${projectId}`, method: 'GET', signal },
    options,
  );
};

export const getGetProjectsProjectIdQueryKey = (projectId?: string) => {
  return [`/projects/${projectId}`] as const;
};

export const getGetProjectsProjectIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectsProjectId>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectsProjectId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectsProjectIdQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectsProjectId>>> = ({ signal }) =>
    getProjectsProjectId(projectId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!projectId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectsProjectId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectsProjectIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectsProjectId>>
>;
export type GetProjectsProjectIdQueryError = ErrorType<void>;

export function useGetProjectsProjectId<
  TData = Awaited<ReturnType<typeof getProjectsProjectId>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectsProjectId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectsProjectId>>,
          TError,
          Awaited<ReturnType<typeof getProjectsProjectId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectsProjectId<
  TData = Awaited<ReturnType<typeof getProjectsProjectId>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectsProjectId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectsProjectId>>,
          TError,
          Awaited<ReturnType<typeof getProjectsProjectId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectsProjectId<
  TData = Awaited<ReturnType<typeof getProjectsProjectId>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectsProjectId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 事業詳細取得
 */

export function useGetProjectsProjectId<
  TData = Awaited<ReturnType<typeof getProjectsProjectId>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectsProjectId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectsProjectIdQueryOptions(projectId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 事業更新

部分更新に対応
 * @summary 事業更新
 */
export const updateProject = (
  projectId: string,
  projectUpdateRequest: BodyType<ProjectUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ProjectUpdateResponse>(
    {
      url: `/projects/${projectId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: projectUpdateRequest,
    },
    options,
  );
};

export const getUpdateProjectMutationOptions = <
  TError = ErrorType<ErrorResponse | undefined>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProject>>,
    TError,
    { projectId: string; data: BodyType<ProjectUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProject>>,
  TError,
  { projectId: string; data: BodyType<ProjectUpdateRequest> },
  TContext
> => {
  const mutationKey = ['updateProject'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProject>>,
    { projectId: string; data: BodyType<ProjectUpdateRequest> }
  > = (props) => {
    const { projectId, data } = props ?? {};

    return updateProject(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateProject>>>;
export type UpdateProjectMutationBody = BodyType<ProjectUpdateRequest>;
export type UpdateProjectMutationError = ErrorType<ErrorResponse | undefined>;

/**
 * @summary 事業更新
 */
export const useUpdateProject = <TError = ErrorType<ErrorResponse | undefined>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProject>>,
      TError,
      { projectId: string; data: BodyType<ProjectUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateProject>>,
  TError,
  { projectId: string; data: BodyType<ProjectUpdateRequest> },
  TContext
> => {
  const mutationOptions = getUpdateProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 事業削除

論理削除ではなく物理削除を実行

 * @summary 事業削除
 */
export const deleteProject = (
  projectId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<DeleteProjectResponse>(
    { url: `/projects/${projectId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteProjectMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProject>>,
    TError,
    { projectId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProject>>,
  TError,
  { projectId: string },
  TContext
> => {
  const mutationKey = ['deleteProject'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProject>>,
    { projectId: string }
  > = (props) => {
    const { projectId } = props ?? {};

    return deleteProject(projectId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProjectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProject>>>;

export type DeleteProjectMutationError = ErrorType<void>;

/**
 * @summary 事業削除
 */
export const useDeleteProject = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteProject>>,
      TError,
      { projectId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteProject>>,
  TError,
  { projectId: string },
  TContext
> => {
  const mutationOptions = getDeleteProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 事業に紐づくRAG検索チャットを取得します

 * @summary 事業のRAG検索チャット取得
 */
export const getProjectReferenceChat = (
  projectId: string,
  referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants',
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ProjectReferenceChatDetailResponse>(
    { url: `/projects/${projectId}/references/chats/${referenceChatType}`, method: 'GET', signal },
    options,
  );
};

export const getGetProjectReferenceChatQueryKey = (
  projectId?: string,
  referenceChatType?: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants',
) => {
  return [`/projects/${projectId}/references/chats/${referenceChatType}`] as const;
};

export const getGetProjectReferenceChatQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectReferenceChat>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectReferenceChat>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProjectReferenceChatQueryKey(projectId, referenceChatType);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectReferenceChat>>> = ({
    signal,
  }) => getProjectReferenceChat(projectId, referenceChatType, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(projectId && referenceChatType),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getProjectReferenceChat>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetProjectReferenceChatQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectReferenceChat>>
>;
export type GetProjectReferenceChatQueryError = ErrorType<void>;

export function useGetProjectReferenceChat<
  TData = Awaited<ReturnType<typeof getProjectReferenceChat>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants',
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectReferenceChat>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectReferenceChat>>,
          TError,
          Awaited<ReturnType<typeof getProjectReferenceChat>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectReferenceChat<
  TData = Awaited<ReturnType<typeof getProjectReferenceChat>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectReferenceChat>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectReferenceChat>>,
          TError,
          Awaited<ReturnType<typeof getProjectReferenceChat>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectReferenceChat<
  TData = Awaited<ReturnType<typeof getProjectReferenceChat>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectReferenceChat>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 事業のRAG検索チャット取得
 */

export function useGetProjectReferenceChat<
  TData = Awaited<ReturnType<typeof getProjectReferenceChat>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectReferenceChat>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectReferenceChatQueryOptions(
    projectId,
    referenceChatType,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 事業に紐づくRAG検索チャットを作成します

チャットは質問のみが作成されるので、回答は別エンドポイントで更新します。

 * @summary 事業のRAG検索チャット作成
 */
export const createProjectReferenceChat = (
  projectId: string,
  referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants',
  projectReferenceChatCreateRequest: BodyType<ProjectReferenceChatCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/projects/${projectId}/references/chats/${referenceChatType}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: projectReferenceChatCreateRequest,
      signal,
    },
    options,
  );
};

export const getCreateProjectReferenceChatMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProjectReferenceChat>>,
    TError,
    {
      projectId: string;
      referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants';
      data: BodyType<ProjectReferenceChatCreateRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProjectReferenceChat>>,
  TError,
  {
    projectId: string;
    referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants';
    data: BodyType<ProjectReferenceChatCreateRequest>;
  },
  TContext
> => {
  const mutationKey = ['createProjectReferenceChat'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProjectReferenceChat>>,
    {
      projectId: string;
      referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants';
      data: BodyType<ProjectReferenceChatCreateRequest>;
    }
  > = (props) => {
    const { projectId, referenceChatType, data } = props ?? {};

    return createProjectReferenceChat(projectId, referenceChatType, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProjectReferenceChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProjectReferenceChat>>
>;
export type CreateProjectReferenceChatMutationBody = BodyType<ProjectReferenceChatCreateRequest>;
export type CreateProjectReferenceChatMutationError = ErrorType<void>;

/**
 * @summary 事業のRAG検索チャット作成
 */
export const useCreateProjectReferenceChat = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createProjectReferenceChat>>,
      TError,
      {
        projectId: string;
        referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants';
        data: BodyType<ProjectReferenceChatCreateRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createProjectReferenceChat>>,
  TError,
  {
    projectId: string;
    referenceChatType: 'special_allocation_taxes' | 'national_grants' | 'prefectural_grants';
    data: BodyType<ProjectReferenceChatCreateRequest>;
  },
  TContext
> => {
  const mutationOptions = getCreateProjectReferenceChatMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 事業に紐づくエージェントチャットスレッドの一覧を取得します。

 * @summary エージェントチャットスレッド一覧取得
 */
export const listAgentChatThreads = (
  projectId: string,
  params?: ListAgentChatThreadsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ProjectAgentChatThreadListResponse>(
    { url: `/projects/${projectId}/agent-chat-threads`, method: 'GET', params, signal },
    options,
  );
};

export const getListAgentChatThreadsQueryKey = (
  projectId?: string,
  params?: ListAgentChatThreadsParams,
) => {
  return [`/projects/${projectId}/agent-chat-threads`, ...(params ? [params] : [])] as const;
};

export const getListAgentChatThreadsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAgentChatThreads>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  params?: ListAgentChatThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAgentChatThreads>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAgentChatThreadsQueryKey(projectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentChatThreads>>> = ({ signal }) =>
    listAgentChatThreads(projectId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!projectId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAgentChatThreads>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAgentChatThreadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAgentChatThreads>>
>;
export type ListAgentChatThreadsQueryError = ErrorType<void>;

export function useListAgentChatThreads<
  TData = Awaited<ReturnType<typeof listAgentChatThreads>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  params: undefined | ListAgentChatThreadsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAgentChatThreads>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentChatThreads>>,
          TError,
          Awaited<ReturnType<typeof listAgentChatThreads>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentChatThreads<
  TData = Awaited<ReturnType<typeof listAgentChatThreads>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  params?: ListAgentChatThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAgentChatThreads>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentChatThreads>>,
          TError,
          Awaited<ReturnType<typeof listAgentChatThreads>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentChatThreads<
  TData = Awaited<ReturnType<typeof listAgentChatThreads>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  params?: ListAgentChatThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAgentChatThreads>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary エージェントチャットスレッド一覧取得
 */

export function useListAgentChatThreads<
  TData = Awaited<ReturnType<typeof listAgentChatThreads>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  params?: ListAgentChatThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAgentChatThreads>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAgentChatThreadsQueryOptions(projectId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 事業に紐づくエージェントチャットスレッドを作成します。

 * @summary エージェントチャットスレッド作成
 */
export const createAgentChatThread = (
  projectId: string,
  projectAgentChatThreadCreateRequest: BodyType<ProjectAgentChatThreadCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<IdResponse>(
    {
      url: `/projects/${projectId}/agent-chat-threads`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: projectAgentChatThreadCreateRequest,
      signal,
    },
    options,
  );
};

export const getCreateAgentChatThreadMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAgentChatThread>>,
    TError,
    { projectId: string; data: BodyType<ProjectAgentChatThreadCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAgentChatThread>>,
  TError,
  { projectId: string; data: BodyType<ProjectAgentChatThreadCreateRequest> },
  TContext
> => {
  const mutationKey = ['createAgentChatThread'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAgentChatThread>>,
    { projectId: string; data: BodyType<ProjectAgentChatThreadCreateRequest> }
  > = (props) => {
    const { projectId, data } = props ?? {};

    return createAgentChatThread(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAgentChatThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAgentChatThread>>
>;
export type CreateAgentChatThreadMutationBody = BodyType<ProjectAgentChatThreadCreateRequest>;
export type CreateAgentChatThreadMutationError = ErrorType<void>;

/**
 * @summary エージェントチャットスレッド作成
 */
export const useCreateAgentChatThread = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAgentChatThread>>,
      TError,
      { projectId: string; data: BodyType<ProjectAgentChatThreadCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAgentChatThread>>,
  TError,
  { projectId: string; data: BodyType<ProjectAgentChatThreadCreateRequest> },
  TContext
> => {
  const mutationOptions = getCreateAgentChatThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * エージェントチャットスレッドの詳細（メッセージ含む）を取得します。

 * @summary エージェントチャットスレッド詳細取得
 */
export const getAgentChatThread = (
  projectId: string,
  threadId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ProjectAgentChatThreadDetailResponse>(
    { url: `/projects/${projectId}/agent-chat-threads/${threadId}`, method: 'GET', signal },
    options,
  );
};

export const getGetAgentChatThreadQueryKey = (projectId?: string, threadId?: string) => {
  return [`/projects/${projectId}/agent-chat-threads/${threadId}`] as const;
};

export const getGetAgentChatThreadQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgentChatThread>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  threadId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentChatThread>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgentChatThreadQueryKey(projectId, threadId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentChatThread>>> = ({ signal }) =>
    getAgentChatThread(projectId, threadId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(projectId && threadId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAgentChatThread>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetAgentChatThreadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAgentChatThread>>
>;
export type GetAgentChatThreadQueryError = ErrorType<void>;

export function useGetAgentChatThread<
  TData = Awaited<ReturnType<typeof getAgentChatThread>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  threadId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentChatThread>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentChatThread>>,
          TError,
          Awaited<ReturnType<typeof getAgentChatThread>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgentChatThread<
  TData = Awaited<ReturnType<typeof getAgentChatThread>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  threadId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAgentChatThread>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentChatThread>>,
          TError,
          Awaited<ReturnType<typeof getAgentChatThread>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgentChatThread<
  TData = Awaited<ReturnType<typeof getAgentChatThread>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  threadId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentChatThread>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary エージェントチャットスレッド詳細取得
 */

export function useGetAgentChatThread<
  TData = Awaited<ReturnType<typeof getAgentChatThread>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  threadId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentChatThread>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAgentChatThreadQueryOptions(projectId, threadId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * エージェントチャットスレッドのタイトルを更新します。

 * @summary エージェントチャットスレッド更新
 */
export const updateAgentChatThread = (
  projectId: string,
  threadId: string,
  projectAgentChatThreadUpdateRequest: BodyType<ProjectAgentChatThreadUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/projects/${projectId}/agent-chat-threads/${threadId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: projectAgentChatThreadUpdateRequest,
    },
    options,
  );
};

export const getUpdateAgentChatThreadMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAgentChatThread>>,
    TError,
    { projectId: string; threadId: string; data: BodyType<ProjectAgentChatThreadUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAgentChatThread>>,
  TError,
  { projectId: string; threadId: string; data: BodyType<ProjectAgentChatThreadUpdateRequest> },
  TContext
> => {
  const mutationKey = ['updateAgentChatThread'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAgentChatThread>>,
    { projectId: string; threadId: string; data: BodyType<ProjectAgentChatThreadUpdateRequest> }
  > = (props) => {
    const { projectId, threadId, data } = props ?? {};

    return updateAgentChatThread(projectId, threadId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAgentChatThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAgentChatThread>>
>;
export type UpdateAgentChatThreadMutationBody = BodyType<ProjectAgentChatThreadUpdateRequest>;
export type UpdateAgentChatThreadMutationError = ErrorType<void>;

/**
 * @summary エージェントチャットスレッド更新
 */
export const useUpdateAgentChatThread = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAgentChatThread>>,
      TError,
      { projectId: string; threadId: string; data: BodyType<ProjectAgentChatThreadUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAgentChatThread>>,
  TError,
  { projectId: string; threadId: string; data: BodyType<ProjectAgentChatThreadUpdateRequest> },
  TContext
> => {
  const mutationOptions = getUpdateAgentChatThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * エージェントチャットスレッドを論理削除します。

 * @summary エージェントチャットスレッド削除
 */
export const deleteAgentChatThread = (
  projectId: string,
  threadId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    { url: `/projects/${projectId}/agent-chat-threads/${threadId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteAgentChatThreadMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAgentChatThread>>,
    TError,
    { projectId: string; threadId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAgentChatThread>>,
  TError,
  { projectId: string; threadId: string },
  TContext
> => {
  const mutationKey = ['deleteAgentChatThread'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAgentChatThread>>,
    { projectId: string; threadId: string }
  > = (props) => {
    const { projectId, threadId } = props ?? {};

    return deleteAgentChatThread(projectId, threadId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAgentChatThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAgentChatThread>>
>;

export type DeleteAgentChatThreadMutationError = ErrorType<void>;

/**
 * @summary エージェントチャットスレッド削除
 */
export const useDeleteAgentChatThread = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAgentChatThread>>,
      TError,
      { projectId: string; threadId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAgentChatThread>>,
  TError,
  { projectId: string; threadId: string },
  TContext
> => {
  const mutationOptions = getDeleteAgentChatThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * エージェントチャットスレッドのお気に入り状態を切り替えます。

 * @summary エージェントチャットスレッドお気に入り切替
 */
export const toggleAgentChatThreadFavorite = (
  projectId: string,
  threadId: string,
  projectAgentChatThreadFavoriteRequest: BodyType<ProjectAgentChatThreadFavoriteRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/projects/${projectId}/agent-chat-threads/${threadId}/favorite`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: projectAgentChatThreadFavoriteRequest,
    },
    options,
  );
};

export const getToggleAgentChatThreadFavoriteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleAgentChatThreadFavorite>>,
    TError,
    { projectId: string; threadId: string; data: BodyType<ProjectAgentChatThreadFavoriteRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof toggleAgentChatThreadFavorite>>,
  TError,
  { projectId: string; threadId: string; data: BodyType<ProjectAgentChatThreadFavoriteRequest> },
  TContext
> => {
  const mutationKey = ['toggleAgentChatThreadFavorite'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof toggleAgentChatThreadFavorite>>,
    { projectId: string; threadId: string; data: BodyType<ProjectAgentChatThreadFavoriteRequest> }
  > = (props) => {
    const { projectId, threadId, data } = props ?? {};

    return toggleAgentChatThreadFavorite(projectId, threadId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ToggleAgentChatThreadFavoriteMutationResult = NonNullable<
  Awaited<ReturnType<typeof toggleAgentChatThreadFavorite>>
>;
export type ToggleAgentChatThreadFavoriteMutationBody =
  BodyType<ProjectAgentChatThreadFavoriteRequest>;
export type ToggleAgentChatThreadFavoriteMutationError = ErrorType<void>;

/**
 * @summary エージェントチャットスレッドお気に入り切替
 */
export const useToggleAgentChatThreadFavorite = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof toggleAgentChatThreadFavorite>>,
      TError,
      {
        projectId: string;
        threadId: string;
        data: BodyType<ProjectAgentChatThreadFavoriteRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof toggleAgentChatThreadFavorite>>,
  TError,
  { projectId: string; threadId: string; data: BodyType<ProjectAgentChatThreadFavoriteRequest> },
  TContext
> => {
  const mutationOptions = getToggleAgentChatThreadFavoriteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * エージェントチャットスレッドに新しいターンを作成します。
ユーザーの質問を保存し、AI応答生成を非同期で開始します。

 * @summary エージェントチャットターン作成
 */
export const createAgentChatTurn = (
  projectId: string,
  threadId: string,
  projectAgentChatCreateTurnRequest: BodyType<ProjectAgentChatCreateTurnRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<IdResponse>(
    {
      url: `/projects/${projectId}/agent-chat-threads/${threadId}/turns`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: projectAgentChatCreateTurnRequest,
      signal,
    },
    options,
  );
};

export const getCreateAgentChatTurnMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAgentChatTurn>>,
    TError,
    { projectId: string; threadId: string; data: BodyType<ProjectAgentChatCreateTurnRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAgentChatTurn>>,
  TError,
  { projectId: string; threadId: string; data: BodyType<ProjectAgentChatCreateTurnRequest> },
  TContext
> => {
  const mutationKey = ['createAgentChatTurn'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAgentChatTurn>>,
    { projectId: string; threadId: string; data: BodyType<ProjectAgentChatCreateTurnRequest> }
  > = (props) => {
    const { projectId, threadId, data } = props ?? {};

    return createAgentChatTurn(projectId, threadId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAgentChatTurnMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAgentChatTurn>>
>;
export type CreateAgentChatTurnMutationBody = BodyType<ProjectAgentChatCreateTurnRequest>;
export type CreateAgentChatTurnMutationError = ErrorType<void>;

/**
 * @summary エージェントチャットターン作成
 */
export const useCreateAgentChatTurn = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAgentChatTurn>>,
      TError,
      { projectId: string; threadId: string; data: BodyType<ProjectAgentChatCreateTurnRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAgentChatTurn>>,
  TError,
  { projectId: string; threadId: string; data: BodyType<ProjectAgentChatCreateTurnRequest> },
  TContext
> => {
  const mutationOptions = getCreateAgentChatTurnMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * エージェントチャットターンの詳細を取得します。
AI応答生成中のステータス確認（ポーリング）に使用します。

 * @summary エージェントチャットターン取得
 */
export const getAgentChatTurn = (
  projectId: string,
  threadId: string,
  turnId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ProjectAgentChatTurnDetailResponse>(
    {
      url: `/projects/${projectId}/agent-chat-threads/${threadId}/turns/${turnId}`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetAgentChatTurnQueryKey = (
  projectId?: string,
  threadId?: string,
  turnId?: string,
) => {
  return [`/projects/${projectId}/agent-chat-threads/${threadId}/turns/${turnId}`] as const;
};

export const getGetAgentChatTurnQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgentChatTurn>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  threadId: string,
  turnId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentChatTurn>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAgentChatTurnQueryKey(projectId, threadId, turnId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentChatTurn>>> = ({ signal }) =>
    getAgentChatTurn(projectId, threadId, turnId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(projectId && threadId && turnId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAgentChatTurn>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetAgentChatTurnQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentChatTurn>>>;
export type GetAgentChatTurnQueryError = ErrorType<void>;

export function useGetAgentChatTurn<
  TData = Awaited<ReturnType<typeof getAgentChatTurn>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  threadId: string,
  turnId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentChatTurn>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentChatTurn>>,
          TError,
          Awaited<ReturnType<typeof getAgentChatTurn>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgentChatTurn<
  TData = Awaited<ReturnType<typeof getAgentChatTurn>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  threadId: string,
  turnId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentChatTurn>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentChatTurn>>,
          TError,
          Awaited<ReturnType<typeof getAgentChatTurn>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgentChatTurn<
  TData = Awaited<ReturnType<typeof getAgentChatTurn>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  threadId: string,
  turnId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentChatTurn>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary エージェントチャットターン取得
 */

export function useGetAgentChatTurn<
  TData = Awaited<ReturnType<typeof getAgentChatTurn>>,
  TError = ErrorType<void>,
>(
  projectId: string,
  threadId: string,
  turnId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentChatTurn>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAgentChatTurnQueryOptions(projectId, threadId, turnId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 事業にタグを紐付ける。
既に紐付いている場合は何もせず成功を返す（冪等）。

 * @summary 事業タグ紐付け追加
 */
export const createProjectTagProject = (
  projectId: string,
  tagId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponse>(
    { url: `/projects/${projectId}/tags/${tagId}`, method: 'POST', signal },
    options,
  );
};

export const getCreateProjectTagProjectMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProjectTagProject>>,
    TError,
    { projectId: string; tagId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProjectTagProject>>,
  TError,
  { projectId: string; tagId: string },
  TContext
> => {
  const mutationKey = ['createProjectTagProject'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProjectTagProject>>,
    { projectId: string; tagId: string }
  > = (props) => {
    const { projectId, tagId } = props ?? {};

    return createProjectTagProject(projectId, tagId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProjectTagProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProjectTagProject>>
>;

export type CreateProjectTagProjectMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 事業タグ紐付け追加
 */
export const useCreateProjectTagProject = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createProjectTagProject>>,
      TError,
      { projectId: string; tagId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createProjectTagProject>>,
  TError,
  { projectId: string; tagId: string },
  TContext
> => {
  const mutationOptions = getCreateProjectTagProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 事業からタグの紐付けを削除する。
既に紐付いていない場合は何もせず成功を返す（冪等）。

 * @summary 事業タグ紐付け削除
 */
export const deleteProjectTagProject = (
  projectId: string,
  tagId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    { url: `/projects/${projectId}/tags/${tagId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteProjectTagProjectMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProjectTagProject>>,
    TError,
    { projectId: string; tagId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProjectTagProject>>,
  TError,
  { projectId: string; tagId: string },
  TContext
> => {
  const mutationKey = ['deleteProjectTagProject'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProjectTagProject>>,
    { projectId: string; tagId: string }
  > = (props) => {
    const { projectId, tagId } = props ?? {};

    return deleteProjectTagProject(projectId, tagId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProjectTagProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProjectTagProject>>
>;

export type DeleteProjectTagProjectMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 事業タグ紐付け削除
 */
export const useDeleteProjectTagProject = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteProjectTagProject>>,
      TError,
      { projectId: string; tagId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteProjectTagProject>>,
  TError,
  { projectId: string; tagId: string },
  TContext
> => {
  const mutationOptions = getDeleteProjectTagProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
